<template>
  <div class="page-content">
    <div class="administrador-heading">
      <h5>{{ $t("lang.admin.online_order.page_title") }}</h5>
    </div>
    <div class="centros-formbg">
      <h6 v-if="step === 1">
        {{ $t("lang.admin.online_order.add_form_title1") }}
      </h6>
      <h6 v-if="step === 2">
        {{ $t("lang.admin.online_order.add_form_title2") }}
      </h6>
      <div class="centros-form">
        <div v-if="errors.length">
          <b>{{ $t("lang.admin.purchase_order.error_list_title") }}</b>
          <div class="alert alert-danger" role="alert">
            <ul style="list-style-type: circle; margin: 10px">
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
        </div>

        <form v-if="step === 1">
          <div class="form-row d-flex align-items-end">
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.admin.purchase_order.order_code')"
                outlined
                v-model="input.order_code"
              ></v-text-field>
            </div>
          </div>
          <div class="form-row">
            <div class="mb-0 col-md-12">
              <v-btn text rounded type="reset" @click="$router.back()">{{
                $t("lang.admin.purchase_order.btn_cancel")
              }}</v-btn>
              <bx-btn class="mx-2" color="primary" @click="handleNext">{{
                $t("lang.admin.purchase_order.btn_next")
              }}</bx-btn>
            </div>
          </div>
        </form>
        <div v-if="step === 2">
          <bx-btn
            class="mx-2"
            color="primary"
            @click="$refs.addOrderBoxDialogRef.open(input.order_code)"
          >
            {{ $t("lang.admin.purchase_order.add_box") }}</bx-btn
          >

          <div class="select-box col-md-12 px-12">
            <bx-table
              :data="boxes"
              :columns="boxTableColumns"
              bordered
              :loading="loading"
              topColor="#9AC31C"
            >
              <template slot-scope="props">
                <bx-table-column>{{ props.row.box_id }}</bx-table-column>
                <bx-table-column>{{ props.row.gtinsCount }}</bx-table-column>
                <bx-table-column
                  ><v-icon @click="removeBox(props)"
                    >mdi-cancel</v-icon
                  ></bx-table-column
                >
              </template>
            </bx-table>
          </div>
          <bx-btn class="mx-2 mt-6" color="primary" @click="btnDone">{{
            $t("lang.admin.purchase_order.btn_done")
          }}</bx-btn>
        </div>
      </div>
    </div>

    <AddOrderBoxDialog
      ref="addOrderBoxDialogRef"
      :reception_id="reception_id"
      @boxAdded="onBoxAdded"
    />
  </div>
</template>

<script>
import AddOrderBoxDialog from "@/components/AddOrderBoxDialog";
import moment from "moment";
let Input = () => {
  return {
    order_code: null,
    origin_id: parseInt(localStorage.getItem("location_id") || 0),
    origin_status: 0,
  };
};

const boxTableColumns = [
  {
    label: "Box",
    field: "box_id",
  },
  {
    label: "Gtins count",
    field: "gtin",
  },
  { label: "Action", field: "action" },
];

export default {
  name: "AddPurchaseOrderForm",
  components: {
    AddOrderBoxDialog,
  },
  data() {
    return {
      input: new Input(),
      errors: [],
      step: 1,
      menu: false,
      reception_id: null,
      errorLabels: {
        location: this.$t("lang.admin.device_form.errors.location"),
        failed: this.$t("lang.messages.label_something_went_wrong"),
      },
      loading: false,
      boxes: [],
      boxTableColumns: [...boxTableColumns],
    };
  },
  watch: {
    step(newValue) {
      if (newValue === 1) {
        this.input = new Input();
      }
    },
  },
  methods: {
    btnDone() {
      this.step = 1;
      this.boxes = [];
    },
    async handleNext() {
      let input = Object.assign({}, this.input, {
        estimated_arrival_date: moment().format("YYYY-MM-DD HH:mm:ss"),
      });

      if (this.validate()) {
        try {
          let response = await this.$api.orders.addOrder(input);
          if (response) {
            this.reception_id = await this.$api.receptions.create({
              reception_code: this.input.order_code,
              order_id: response.order,
            });
            this.step += 1;
          }
        } catch (error) {
          this.errors.push(this.errorLabels.failed);
        }
      }
    },
    onBoxAdded(data) {
      this.boxes.push(data);
    },
    async removeBox(props) {
      try {
        this.loading = true;
        await this.$api.reception_boxes.deleteBox(props.row.id);
        this.boxes.splice(props.index, 1);
      } catch (error) {
        console.error(error);
      } finally {
        this.boxTableColumns = [...boxTableColumns];
        this.loading = false;
      }
    },
    validate() {
      this.errors = [];
      let error = false;
      if (error) {
        return false;
      }
      return true;
    },
  },
};
</script>
